const Fonts = {
	barlow: 'barlow',
	barlowMedium: 'barlow-medium',
	barlowBold: 'barlow-bold',
	barlowItalic: 'barlow-italic',
	ptSerif: 'pt-serif',
	webInputStack: 'Roboto, "Helvetica Neue", Helvetica, Arial, sans-serif',
};

export default Fonts;
